module.exports = __webpack_public_path__ + "static/media/seekBusinessLogo.db1576c2.png";